import { useEffect, useState } from "react";
import { useParams, useSearchParams, Link } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import { api, track } from "../../lib/api";
import { buildOfferLink } from "../../lib/offers";
import { useSettings } from "../../context/SettingsContext";
import { Logo } from "../../components/Logo";
import { b2cPath } from "../../lib/host";

export default function GoRedirect() {
  const { slug, code } = useParams();
  const [searchParams] = useSearchParams();
  const { settings } = useSettings();
  const [airline, setAirline] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    api.get(`/airlines/${slug}`).then((r) => setAirline(r.data)).catch(() => setError(true));
  }, [slug]);

  useEffect(() => {
    if (!airline || !settings) return;
    const destCode = code.toUpperCase();
    const dest = airline.top_destinations.find((d) => d.code === destCode) || { code: destCode };
    const link = buildOfferLink(settings, airline, dest);
    track("booking_handoff", `/go/${slug}/${destCode}`, {
      source: "go_link",
      dest: destCode,
      campaign: searchParams.get("utm_campaign") || searchParams.get("c") || "",
      url: link,
    });
    const t = setTimeout(() => window.location.replace(link), 900);
    return () => clearTimeout(t);
  }, [airline, settings, code, slug, searchParams]);

  return (
    <div className="min-h-screen bg-[#00172D] flex items-center justify-center px-4" data-testid="go-redirect-page">
      <div className="text-center">
        <div className="flex justify-center mb-6">
          <Logo dark />
        </div>
        {error ? (
          <>
            <p className="text-white font-heading font-bold text-xl">Link not found</p>
            <p className="text-slate-400 text-sm mt-2">This campaign link is no longer active.</p>
            <Link to={b2cPath("") || "/"} className="inline-block mt-5 bg-[#970C10] text-white text-sm font-bold px-6 py-2.5 rounded-full">
              Browse flight deals
            </Link>
          </>
        ) : (
          <>
            <div className="w-10 h-10 mx-auto border-4 border-white/20 border-t-[#970C10] rounded-full animate-spin" />
            <p className="text-white font-heading font-bold text-xl mt-6">
              Finding live {airline ? airline.name : ""} fares...
            </p>
            <p className="text-slate-400 text-sm mt-2 flex items-center justify-center gap-1.5">
              <ShieldCheck className="w-4 h-4 text-[#E8767A]" /> Authorised booking partner · fresh fares for the next departure
            </p>
          </>
        )}
      </div>
    </div>
  );
}
